  export class Stampdatetime {
  id: number;
  description: string;
  positionX: number;
  positionY: number;
  widthContainer: number;
  heightContainer: number;
  pageStamp: number;
  stampOn: number;
  active: number;
}
